var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 13,
    viewBox: "0 0 3 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.44444C0 0.6467 0.6467 0 1.44444 0C2.24219 0 2.88889 0.6467 2.88889 1.44444C2.88889 2.24219 2.24219 2.88889 1.44444 2.88889C0.6467 2.88889 0 2.24219 0 1.44444ZM0 6.5C0 5.70226 0.6467 5.05556 1.44444 5.05556C2.24219 5.05556 2.88889 5.70226 2.88889 6.5C2.88889 7.29774 2.24219 7.94444 1.44444 7.94444C0.6467 7.94444 0 7.29774 0 6.5ZM1.44444 10.1111C0.6467 10.1111 0 10.7578 0 11.5556C0 12.3533 0.6467 13 1.44444 13C2.24219 13 2.88889 12.3533 2.88889 11.5556C2.88889 10.7578 2.24219 10.1111 1.44444 10.1111Z",
    fill: "#5B6885"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/More.c29c26bd.svg";
export { ForwardRef as ReactComponent };